import React from 'react';
import Loader from '../../common/Loader';
import { useFetchExtraEvents } from '../../data/fetchExtraEvents';
import { labels } from '../../data/labels';
import { PrematchDataContext } from '../PrematchDataFetcher';
import Events from './Events';

export default function ExtraEvents(props) {
    const prematchData = React.useContext(PrematchDataContext);

    const [request] = useFetchExtraEvents(prematchData);
    
    if (request.isLoading || request.isError) {
        return <Loader isError={request.isError} />
    }

    return (
        <div id="avvenimenti">
            <>
                <Events items={request.data.cota} title={labels['prematch.extra_events.cota']} />
                <Events items={request.data.extra} title={labels['prematch.extra_events.extra']} />
            </>
        </div>
    );
}
